import { sortBy } from '../utils/utils';
const isPerformanceMethodSupported = method => globalThis.performance && typeof globalThis.performance[method] === 'function';
export const now = () => isPerformanceMethodSupported('now') ? performance.now() : 0;
export const mark = name => isPerformanceMethodSupported('mark') ? performance.mark(name) : undefined;
export const measure = function () {
  return isPerformanceMethodSupported('measure') ? performance.measure(...arguments) : undefined;
};
export const getEntries = function () {
  return isPerformanceMethodSupported('getEntries') ? performance.getEntries(...arguments) : [];
};
export const getEntriesByName = function () {
  return isPerformanceMethodSupported('getEntriesByName') ? performance.getEntriesByName(...arguments) : [];
};
export const clearMarks = () => isPerformanceMethodSupported('clearMarks') ? performance.clearMarks() : undefined;
export const clearMeasures = () => isPerformanceMethodSupported('clearMeasures') ? performance.clearMeasures() : undefined;
export const getDurationBetweenMarks = (startMark, endMark) => {
  if (!isPerformanceMethodSupported('measure')) {
    return 0;
  }
  const markName = `${startMark}-${endMark}`;
  measure(markName, startMark, endMark);
  const lastEntry = getEntriesByName(markName).pop();
  return lastEntry && lastEntry.duration || 0;
};
export const getResourceTimingByUrl = url => {
  const entries = getEntries();
  if (!entries) {
    return null;
  }
  const performanceEntries = entries.filter(function (entry) {
    return entry.name.indexOf(url) >= 0;
  });
  return sortBy(performanceEntries, 'startTime').pop();
};